var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.member
    ? _c("tr", { staticClass: "md-table-row" }, [
        _c("td", { staticClass: "md-table-cell" }, [
          _c("div", { staticClass: "md-table-cell-container" }, [
            _c(
              "span",
              {
                staticClass: "display-link",
                on: {
                  click: function($event) {
                    return _vm.goToProfile()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.displayName(_vm.member)))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "md-table-cell" }, [
          _c("div", { staticClass: "md-table-cell-container" }, [
            _c(
              "span",
              {
                staticClass: "display-link",
                on: {
                  click: function($event) {
                    return _vm.goToProfile()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.member.emails[0]))]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.$lodash.has(_vm.member.request, "lastRequest")
          ? _c("td", { staticClass: "md-table-cell" }, [
              _c("div", { staticClass: "md-table-cell-container" }, [
                _vm._v(
                  _vm._s(_vm._f("momentDate")(_vm.member.request.lastRequest))
                )
              ])
            ])
          : _c("td", { staticClass: "md-table-cell" }, [
              _c("div", { staticClass: "md-table-cell-container" }, [
                _vm._v("---")
              ])
            ]),
        _vm._v(" "),
        _vm.$lodash.has(_vm.member.response, "lastResponse")
          ? _c("td", { staticClass: "md-table-cell" }, [
              _c("div", { staticClass: "md-table-cell-container" }, [
                _vm._v(
                  _vm._s(_vm._f("momentDate")(_vm.member.response.lastResponse))
                )
              ])
            ])
          : _c("td", { staticClass: "md-table-cell" }, [
              _c("div", { staticClass: "md-table-cell-container" }, [
                _vm._v("---")
              ])
            ]),
        _vm._v(" "),
        _vm.$lodash.has(_vm.member, "lastFeedback")
          ? _c("td", { staticClass: "md-table-cell" }, [
              _c("div", { staticClass: "md-table-cell-container" }, [
                _vm._v(_vm._s(_vm._f("momentDate")(_vm.member.lastFeedback)))
              ])
            ])
          : _c("td", { staticClass: "md-table-cell" }, [
              _c("div", { staticClass: "md-table-cell-container" }, [
                _vm._v("---")
              ])
            ]),
        _vm._v(" "),
        _vm.section === "communityMembers"
          ? _c("td", { staticClass: "md-table-cell" }, [
              _c("div", { staticClass: "md-table-cell-container" }, [
                _vm._v(_vm._s(_vm.displayStatus(_vm.member)))
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7e3586c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7e3586c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member.vue
// module id = null
// module chunks = 